import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { chevronDownIcon } from '../../../icons';
import { FacetStateService } from '../../core/facet-state.service';
import { IExchangeCar } from '../../exchange-car/exchange-car.models';
import { ExchangeCarService } from '../../exchange-car/exchange-car.service';
import { ExpansionPanelComponent } from '../../expansion-panel/expansion-panel.component';
import { FilterService } from '../../filter-service/filter.service';
import { COLLAPSE_PANELS } from '../../models/filter.models';
import { SidePanelService } from '../../side-panel/side-panel.service';

@Component({
    selector: 'app-exchange-car-value-facet',
    template: `
        <div class="facet exchange-car-facet">
            <app-expansion-panel #panel [headerClickable]="true" [expanded]="expandPanel" (changed)="onPanelChange($event)">
                <h6 class="facet__title" expansion-title [class.facet__title--no-margin]="!panel.animating && !panel.expanded">
                    {{ 'filterpage.exchange_car_facet____title' | translate }}
                </h6>
                <ng-container expansion-icon>${chevronDownIcon}</ng-container>
                <div class="facet__content">
                    <app-value-input
                        [currentValue]="filterService.exchangeCarValue | async"
                        (handleChange)="handleInputChange($event)"
                    ></app-value-input>
                    <ng-container *ngIf="(exchangeCarService.exchangeCars | async)?.length">
                        <p class="text-secondary text-small">{{ 'filterpage.exchange_car_facet____list_title' | translate }}</p>
                        <ng-container *ngIf="exchangeCarService.exchangeCars | async as cars">
                            <button class="button--minimal exchange-car-facet__car" *ngFor="let car of cars" (click)="handleClick(car)">
                                <p class="exchange-car-facet__car-title">
                                    {{ car.make?.summary }} {{ car.model?.summary }}
                                    <span *ngIf="car.identifier">- {{ car.identifier }}</span>
                                </p>
                                <p class="no-margin" *ngFor="let valuation of car?.valuations">
                                    {{ valuation?.amount?.value | defaultcurrency }}
                                </p>
                            </button>
                        </ng-container>
                    </ng-container>
                    <app-button
                        (handleClick)="handleIndicataClick()"
                        buttonClass="button--as-link brand-color exchange-car-facet__add-new"
                        [title]="'filterpage.exchange_car_facet____add_new_calculation' | translate"
                    ></app-button>
                </div>
            </app-expansion-panel>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExchangeCarValueFacetComponent implements OnInit {
    @ViewChild('panel') panel: ExpansionPanelComponent;

    expandPanel = true;

    panelLabel = 'exchangeCarFacet';

    constructor(
        private sidepanelService: SidePanelService,
        public exchangeCarService: ExchangeCarService,
        public filterService: FilterService,
        private readonly facetStateService: FacetStateService,
        @Optional() @Inject(COLLAPSE_PANELS) private collapsePanels: boolean
    ) {}

    ngOnInit(): void {
        const expandState = this.facetStateService.getExpandedState(this.panelLabel);
        this.expandPanel = expandState ?? this.collapsePanels ?? true;
    }

    handleIndicataClick() {
        this.sidepanelService.showExhangeCarSidePanel(true);
    }

    handleInputChange(value?: string) {
        const val = parseInt(value || '');
        const newValue = isNaN(val) ? 0 : val;
        this.submitNewExchangeCarValue(newValue);
    }
    handleClick(car?: IExchangeCar) {
        this.submitNewExchangeCarValue(car?.valuations?.[0]?.amount?.value || 0);
    }
    submitNewExchangeCarValue(value?: number) {
        this.filterService.setExchangeCarValue(value || 0);
    }

    onPanelChange(value: boolean) {
        if (value) {
            this.facetStateService.storeFacetAsExpanded(this.panelLabel);
        } else {
            this.facetStateService.storeFacetAsColapsed(this.panelLabel);
        }
    }
}
